import React from 'react';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { socialLoginRedirectUrl, socialLoginRevoke } from '../Common/Providers/SocialLoginApi';
import { connectUserHeaderinfo } from '../Auth/WithUserHeaderInfo';
import { withTranslationProvider } from '../Common/Translations';

const handleFacebookConnect = () => {
  socialLoginRedirectUrl(data.provider)
  .done((response) => {
    window.location = response.data.redirect_url;
  })
};

const handleFacebookRevoke = () => {
  socialLoginRevoke(data.provider)
  .done(() => {
    window.location.reload();
  })
};

const handleFacebookRefreshTokenAndRevoke = () => {
  socialLoginRedirectUrl(data.provider, { action: 'unlink' })
  .done((response) => {
    window.location = response.data.redirect_url;
  })
};

const linkWithTokenExpiredValidation = ({isLinked, isTokenExpired}) => () => {
  if(isLinked && isTokenExpired) {
    handleFacebookRefreshTokenAndRevoke()
  } else if(isLinked && !isTokenExpired) {
    handleFacebookRevoke()
  } else {
    handleFacebookConnect()
  }
};

const data = { 
  provider: 'facebook',
};

const ConnectWithFacebook = (props) => {
  const {
    isLinked,
    t,
  } = props;

  return (
    <div className="col-md-auto mb-3">
      <button
        className = "btn btn-primary"
        id = "btn-social-login"
        onClick = { () => props.linkWithTokenExpiredValidation() }>
        <span className="fa fa-facebook pr-4"></span> 
        { isLinked ? t('account.unlink_fb','Unlink from Facebook') : t('account.connect_fb','Connect with Facebook') }
      </button>
    </div>
  );
}

const enhance = compose(
  connectUserHeaderinfo,
  withTranslationProvider,
  withState('isLinked', 'setIsLinked', false),
  withState('isTokenExpired', 'setIsTokenExpired', false),
  withHandlers({
    linkWithTokenExpiredValidation
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        userHeaderInfo: {
          hasSocialMediaLink = {}
        }
      } = this.props;
      const fbLink = hasSocialMediaLink.facebook || {};
      const { isLinked = false, isTokenExpired = false } = fbLink;
  
      if (isLinked !== prevProps.isLinked) {
        this.props.setIsLinked(isLinked);
      }
  
      if (isTokenExpired !== prevProps.isTokenExpired) {
        this.props.setIsTokenExpired(isTokenExpired);
      }
    }
  }),
);

export default enhance(ConnectWithFacebook);
export const undecorated = ConnectWithFacebook;



// WEBPACK FOOTER //
// ./src/Account/ConnectWithFacebook.js